export default {
    drawerWidth: 300,
    drawerMiniWidth: 60,
    drawerPaperWidth:240
}
